import { ComputeProvisioningEligibility } from '@schema';
import i18n from '@/common/i18n';
import { COMPUTE_PROVISIONING_ELIGIBILITY_REASON_TEXT } from '@/common/constants/computeProvisioning.constants';

const BLOCKED_ELIGIBILITY_ACTIONS: ComputeProvisioningEligibility.action[] = [
  ComputeProvisioningEligibility.action.BLOCKED,
  ComputeProvisioningEligibility.action.UNAVAILABLE
];

const RESUMABLE_ELIGIBILITY_ACTIONS: ComputeProvisioningEligibility.action[] = [
  ComputeProvisioningEligibility.action.CONTINUE,
  ComputeProvisioningEligibility.action.RECOVER
];

export const isEligibilityBlocked = (
  eligibility: ComputeProvisioningEligibility | null
): boolean => !!eligibility && BLOCKED_ELIGIBILITY_ACTIONS.includes(eligibility.action as ComputeProvisioningEligibility.action);

export const isEligibilityResumable = (
  eligibility: ComputeProvisioningEligibility | null
): boolean => !!eligibility && RESUMABLE_ELIGIBILITY_ACTIONS.includes(eligibility.action as ComputeProvisioningEligibility.action);

export const eligibilityReasonText = (
  eligibility: ComputeProvisioningEligibility | null
): string => {
  const text = eligibility?.reason_code
    ? COMPUTE_PROVISIONING_ELIGIBILITY_REASON_TEXT[eligibility.reason_code] || ''
    : '';
  if (!text && isEligibilityBlocked(eligibility)) {
    return i18n.t('Compute provisioning is not available right now.') as string;
  }
  return text;
};
